module.exports = __webpack_public_path__ + "static/media/in-app.642e5db3.svg";